import { useRef, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Upload, Loader2, FileText } from "lucide-react";
import { toast } from "sonner";

export default function FileUploader({ label = "Upload", onUploaded, testid = "file-uploader" }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded?.(data.path);
      toast.success("File uploaded");
    } catch {
      toast.error("Upload failed");
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };

  return (
    <>
      <input ref={ref} type="file" className="hidden" accept="image/*,application/pdf" onChange={handle} data-testid={`${testid}-input`} />
      <Button type="button" variant="outline" size="sm" disabled={busy} onClick={() => ref.current?.click()} data-testid={`${testid}-btn`}>
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />} {label}
      </Button>
    </>
  );
}

export function FileGrid({ files }) {
  if (!files || files.length === 0) return <div className="text-sm text-gray-400">None yet.</div>;
  return (
    <div className="grid grid-cols-3 gap-2">
      {files.map((f, i) => {
        const path = typeof f === "string" ? f : f.path;
        const isPdf = /\.pdf$/i.test(path);
        return (
          <a key={i} href={fileUrl(path)} target="_blank" rel="noreferrer"
            className="block border border-gray-200 rounded-md overflow-hidden hover:border-[#0047FF] transition-colors" data-testid={`file-thumb-${i}`}>
            {isPdf ? (
              <div className="h-24 flex items-center justify-center bg-gray-50 text-gray-500"><FileText className="h-8 w-8" /></div>
            ) : (
              <img src={fileUrl(path)} alt="" className="h-24 w-full object-cover" />
            )}
          </a>
        );
      })}
    </div>
  );
}
